export default "__VITE_ASSET__09c6fdc7__"